import type { user } from '../types'

type TimekeeperViewUser =
  | Pick<user, 'is_admin' | 'is_billing_admin'>
  | null
  | undefined

export const canViewAllTimekeepers = (candidate: TimekeeperViewUser) =>
  candidate?.is_admin === true || candidate?.is_billing_admin === true
